import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as Highcharts from 'highcharts';
import 'rc-tree/assets/index.css';
import React, { StrictMode } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { RouterProvider } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import '@assets/app.scss';

import { parseJson } from '@helpers/parseJson';

import { isHostnameAws } from '@services/apiClient';

import ErrorBoundary from './components/common/ErrorBoundary/ErrorBoundary';
import './constants/styles/fonts.scss';
import { router } from './router';

Highcharts.AST.allowedAttributes.push(
  'viewBox',
  'data-reactroot',
  'xmlns',
  'data-tooltip-id',
  'data-tooltip-content',
  'fill-rule',
  'clip-rule',
);
Highcharts.AST.allowedReferences.push('data:image/svg+xml;base64');
Highcharts.setOptions({
  lang: {
    thousandsSep: '',
  },
  tooltip: {
    className: 'tooltip',
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      cacheTime: 60 * 1000,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error?.response?.status === 422) {
        const message = parseJson(error.response?.data?.message);

        if (message?.errors?.message === 'Incorrect Domain') {
          const pathname = window.location.pathname;
          const redirectUrl = (isHostnameAws ? APP_DOMAIN_AZURE : APP_DOMAIN_AWS) + pathname;

          window.location.replace(redirectUrl);
        }
      }
    },
  }),
});

const matomoInstance = createInstance({
  urlBase: APP_MATOMO_URL,
  siteId: APP_MATOMO_SITE_ID,
  linkTracking: false,
  disabled: IS_DEV_SERVER,
});

const App = () => {
  return (
    <StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <MatomoProvider value={matomoInstance}>
            <RouterProvider router={router} />
          </MatomoProvider>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </ErrorBoundary>
    </StrictMode>
  );
};

export default App;
